/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AccountPlanConfig } from './accountPlanConfig';
import { PaymentType } from './paymentType';
import { PaymentStatus } from './paymentStatus';


export interface OrderPaymentApiModel { 
    createdAt: string;
    processedAt?: string | null;
    status: PaymentStatus;
    paymentType: PaymentType;
    planDetail: AccountPlanConfig;
}
export namespace OrderPaymentApiModel {
}


